import {
  SiJavascript,
  SiTypescript,
  SiPython,
  SiJava,
  SiReact,
  SiRedux,
  SiNextdotjs,
  SiHtml5,
  SiCss3,
  SiTailwindcss,
  SiStyledcomponents,
  SiBootstrap,
  SiMaterialui,
  SiNodedotjs,
  SiApollographql,
  SiGraphql,
  SiPostgresql,
  SiMongodb,
  SiSocketdotio,
  SiRedis,
  SiJest,
  SiGit,
  SiPostman,
  SiHeroku,
  SiNpm,
  SiLinux,
  SiVisualstudiocode,
} from 'react-icons/si';
import { ReactComponent as ExpressLogo } from '../svg/express.svg';
import { ReactComponent as CypressLogo } from '../svg/cypress.svg';
import { ReactComponent as SequelizeLogo } from '../svg/sequelize.svg';
import { ReactComponent as TypeormLogo } from '../svg/typeorm.svg';
import { ReactComponent as MongooseLogo } from '../svg/mongoose.svg';

const techSkills = [
  {
    name: 'Languages',
    items: [
      { title: 'JavaScript (ES6+)', icon: <SiJavascript /> },
      { title: 'TypeScript', icon: <SiTypescript /> },
      { title: 'Python', icon: <SiPython /> },
      { title: 'Java', icon: <SiJava /> },
    ],
  },
  {
    name: 'Front-end',
    items: [
      { title: 'React.js', icon: <SiReact /> },
      { title: 'Redux', icon: <SiRedux /> },
      { title: 'Apollo Client', icon: <SiApollographql /> },
      { title: 'Next.js', icon: <SiNextdotjs /> },
      { title: 'HTML5', icon: <SiHtml5 /> },
      { title: 'CSS3', icon: <SiCss3 /> },
      { title: 'Tailwind CSS', icon: <SiTailwindcss /> },
      { title: 'Material-UI', icon: <SiMaterialui /> },
      { title: 'Bootstrap', icon: <SiBootstrap /> },
      { title: 'Styled-Components', icon: <SiStyledcomponents /> },
    ],
  },
  {
    name: 'Back-end',
    items: [
      { title: 'Node.js', icon: <SiNodedotjs /> },
      {
        title: 'Express.js',
        icon: <ExpressLogo />,
      },
      { title: 'GraphQL', icon: <SiGraphql /> },
      { title: 'Apollo Server', icon: <SiApollographql /> },
      { title: 'PostgreSQL', icon: <SiPostgresql /> },
      { title: 'MongoDB', icon: <SiMongodb /> },
      { title: 'Sequelize', icon: <SequelizeLogo /> },
      { title: 'Mongoose', icon: <MongooseLogo /> },
      { title: 'TypeORM', icon: <TypeormLogo /> },
      { title: 'Socket.io', icon: <SiSocketdotio /> },
      { title: 'Redis', icon: <SiRedis /> },
    ],
  },
  {
    name: 'Others',
    items: [
      { title: 'Cypress', icon: <CypressLogo /> },
      { title: 'Jest', icon: <SiJest /> },
      { title: 'Git', icon: <SiGit /> },
      { title: 'Postman', icon: <SiPostman /> },
      { title: 'Heroku', icon: <SiHeroku /> },
      { title: 'NPM', icon: <SiNpm /> },
      { title: 'Linux', icon: <SiLinux /> },
      { title: 'VS Code', icon: <SiVisualstudiocode /> },
    ],
  },
];

export default techSkills;
